import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/admin/quiz/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/admin/quiz/create',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/admin/quiz/update',
      data
    });
  },
  enable(data) {
    return http.post({
      url: '/admin/quiz/enable',
      data,
      dataType: 'form'
    });
  },
  disable(data) {
    return http.post({
      url: '/admin/quiz/disable',
      data,
      dataType: 'form'
    });
  },
  setResult(data) {
    return http.post({
      url: '/admin/quiz/result',
      data,
      dataType: 'form'
    });
  },
  getAllCoins() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  }
};
